import { useDelete } from "../../api";

export function useDetachPaymentMethod() {
  const deleteRequest = useDelete();

  return async (
    partnerId: string,
    subscriptionId: string,
    paymentMethodId: string
  ) => {
    await deleteRequest(
      `/api/v3/portal/partners/${partnerId}/subscriptions/${subscriptionId}/payment_methods/${paymentMethodId}`
    );
  };
}
